import React from "react";
import logoTransparent from "../../assets/newLogo/logoTransparent.png";
import Facebook from "@mui/icons-material/Facebook";
import Instagram from "@mui/icons-material/Instagram";
import * as S from "./Styles";

const Footer = () => {
  return (
    <S.Footer aria-label="Bunnmeny">
      <S.FooterContainer>
        <S.FooterLine />
        <S.RowLine>
          <S.NavbarLogoContainer to="/">
            <S.NavbarLogo src={logoTransparent} alt="Grønvold Bygg logo" />
          </S.NavbarLogoContainer>
          <S.FooterTextContent>
            <h3>Grønvold Byggservice AS</h3>
            <S.FooterText>
              <a href="mailto:agronvold@outlook.com">agronvold@outlook.com</a>
            </S.FooterText>
            <S.FooterText>Org.nr: 934426975</S.FooterText>
          </S.FooterTextContent>
          <S.SocialMediaContainer aria-label="Sosiale medier">
            <S.StyledIcon
              aria-label="Facebook"
              href="https://www.facebook.com/GronvoldBygg.no"
              target="_blank"
            >
              <Facebook style={{ height: "35px", width: "35px" }} />
            </S.StyledIcon>
            <S.StyledIcon
              aria-label="Instagram"
              href="https://www.instagram.com/gronvold_byggservice/"
              target="_blank"
            >
              <Instagram style={{ height: "35px", width: "35px" }} />
            </S.StyledIcon>
          </S.SocialMediaContainer>
        </S.RowLine>
        <S.FooterLine />
      </S.FooterContainer>
    </S.Footer>
  );
};

export default Footer;
